import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ScheduleService } from '../services/schedule.service';

@Component({
    selector: 'app-schedules',
    templateUrl: './schedules.component.html',
    styleUrls: ['./schedules.component.css'],
    providers: [ScheduleService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SchedulesComponent implements OnInit {
  schedules: Array<any>;

  constructor(private scheduleService: ScheduleService, private router: Router) { }

  ngOnInit() {
    this.updateSchedules();
  }

  updateSchedules(): any {

    this.scheduleService.getAll().subscribe(
      data => {
        this.schedules = data;
      },
      error => undefined
      );
    }

    deleteSchedule(scheduleId: string) {
      this.scheduleService.deleteSchedule(scheduleId).subscribe(result => this.updateSchedules());
    }

    editSchedule(scheduleId: string) {
      this.router.navigate(['/schedule/' + scheduleId + '/edit']);
    }
  }
